<template>
  <q-btn
    v-show="visibility !== undefined ? (triggerVisibilityChange ? visibilityState : visibility) : true"
    :loading="loadingState"
    color="#E3EAED"
    :style="{
      backgroundColor: `${backgroundColor}`,
    }"
    class="incredi-button-component"
    no-caps
    unelevated
    v-bind="$attrs"
    :ripple="false"
    :text-color="textColor"
  >
    <slot />
  </q-btn>
</template>

<script>
export default {
  name: 'IncrediButton',
  props: {
    debounceVisibilityLoadingTime: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    visibility: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    textColor: {
      type: String,
      default: 'brand_almost_black',
    },
    backgroundColor: {
      type: String,
    },
  },
  data() {
    return {
      loadingState: false,
      minLoadingTimeExceeded: false,
      visibilityState: false,
      minVisibilityTimeExceeded: false,
      triggerVisibilityChange: false,
    };
  },
  watch: {
    loading(newValue) {
      if (this.loading === undefined) return;
      if (!this.debounceVisibilityLoadingTime || this.minLoadingTimeExceeded) {
        this.minLoadingTimeExceeded = false;
        this.loadingState = newValue;
      } else if (newValue && !this.loadingState) {
        this.loadingState = true;
        setTimeout(() => {
          if (!this.loading) this.loadingState = false;
          else this.minLoadingTimeExceeded = true;
        }, this.debounceVisibilityLoadingTime);
      }
    },
    visibility(newValue) {
      this.triggerVisibilityChange = true;
      if (this.visibility === undefined) return;
      if (!this.debounceVisibilityLoadingTime || this.minVisibilityTimeExceeded) {
        this.minVisibilityTimeExceeded = false;
        this.visibilityState = newValue;
      } else if (newValue && !this.visibilityState) {
        this.visibilityState = true;
        setTimeout(() => {
          if (!this.visibility) this.visibilityState = false;
          else this.minVisibilityTimeExceeded = true;
        }, this.debounceVisibilityLoadingTime);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.incredi-button-component {
  padding: 4px 8px;

  border-radius: 2px;
  font-family: Gordita-Regular;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  :deep(.q-icon) {
    font-size: 12px;
  }

  :deep(.q-btn__wrapper) {
    padding-left: 12px;
    padding-right: 12px;
  }
  :deep(.q-focus-helper) {
    &::before {
      opacity: 1 !important;
    }
    &::after {
      opacity: 1 !important;
    }
  }
}
</style>
